import React, { useState, useMemo, useCallback, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDebounce } from "@/hooks/useDebounce";

export const useProjectFilters = () => {
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  
  const [view, setView] = useState("table");
  const [page, setPage] = useState(1);
  const [sortBy, setSortBy] = useState("-createdAt");
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = searchParams.get('tab') || 'all';

  const [filters, setFilters] = useState({
    status: initialTab,
    activityStatus: "all",
    source: "all",
    city: "all",
    assignedTo: "all",
    serviceType: "all",
    date: "all",
    fromDate: "",
    toDate: ""
  });

  // Sync URL changes to state
  useEffect(() => {
    const currentTab = searchParams.get("tab") || "all";
    setFilters(prev => {
      if (prev.status === currentTab) return prev;
      return {
        ...prev,
        status: currentTab,
      };
    });
  }, [searchParams]);

  const handleFilterChange = useCallback((key, value) => {
    let newStatus = undefined;
    if (typeof key === 'object') {
      setFilters(prev => ({ ...prev, ...key }));
      if (key.status !== undefined) newStatus = key.status;
    } else {
      setFilters(prev => ({ ...prev, [key]: value }));
      if (key === 'status') newStatus = value;
    }
    setPage(1);
    
    if (newStatus !== undefined) {
      setSearchParams(prev => {
        const next = new URLSearchParams(prev);
        if (newStatus === 'all') {
          next.delete('tab');
        } else {
          next.set('tab', newStatus);
        }
        return next;
      });
    }
  }, [setSearchParams]);

  return {
    search, setSearch,
    debouncedSearch,
    view, setView,
    page, setPage,
    sortBy, setSortBy,
    filters, 
    setFilters: handleFilterChange,
    showAdvancedFilters, setShowAdvancedFilters
  };
};
